import { useState } from "react";

const EmojiPicker = ({ onSelect }: { onSelect: (emoji: string) => void }) => {
  const [open, setOpen] = useState(false);
  const emojis = [
    "😀",
    "😃",
    "😄",
    "😁",
    "😆",
    "😂",
    "🤣",
    "😊",
    "😇",
    "🙂",
    "🙃",
    "😉",
    "😍",
    "😘",
    "😗",
    "😚",
    "😙",
    "😋",
    "😜",
    "🤪",
    "😎",
    "🤩",
    "🥳",
    "😏",
    "😒",
    "😞",
    "😔",
    "😢",
    "😭",
    "😤",
    "😡",
    "😱",
    "🤯",
    "😳",
    "🥺",
    "🤔",
    "🤗",
    "🙄",
    "😬",
    "😴",
    "👍",
    "👎",
    "👏",
    "🙌",
    "🙏",
    "💪",
    "🔥",
    "💯",
    "🎉",
    "🚀",
  ];

  const togglePopup = () => setOpen(!open);

  const handleEmojiClick = (emoji: string) => {
    onSelect(emoji);
    setOpen(false); // close after selecting
  };

  return (
    <div className="relative inline-flex">
      {/* Emoji toggle button */}
      <button
        type="button"
        onClick={togglePopup}
        className="text-2xl p-1 hover:bg-gray-100 rounded"
      >
        <svg
          stroke="currentColor"
          fill="currentColor"
          strokeWidth="0"
          viewBox="0 0 496 512"
          height="1em"
          width="1em"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm-80-216c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32zm160 0c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32zm4 72.6c-20.8 25-51.5 39.4-84 39.4s-63.2-14.3-84-39.4c-8.5-10.2-23.7-11.5-33.8-3.1-10.2 8.5-11.5 23.6-3.1 33.8 30 36 74.1 56.6 120.9 56.6s90.9-20.6 120.9-56.6c8.5-10.2 7.1-25.3-3.1-33.8-10.1-8.4-25.3-7.1-33.8 3.1z"></path>
        </svg>
      </button>

      {/* Emoji popup */}
      {/* Popup */}
      {open && (
        <div className="absolute bottom-full left-0 mb-2 z-50 bg-white border border-gray-200 rounded-lg shadow-lg p-3 w-56">
          {/* Recent emojis */}

          {/* Default emojis */}
          <div>
            <div className="text-xs text-gray-500 mb-1">All Emojis</div>
            <div className="grid grid-cols-6 gap-2">
              {emojis.map((emoji) => (
                <button
                  key={emoji}
                  className="text-sm hover:scale-110 transition"
                  onClick={() => handleEmojiClick(emoji)}
                >
                  {emoji}
                </button>
              ))}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default EmojiPicker;
